export default __webpack_public_path__ + "static/thebottomline20-f34bb4b6e9022f01b5f8b1284a741ee5.jpg";